/** Human, Romanian-facing labels for the internal compute-tier ids.
 *
 * The DB stores tiers under musical-tempo codenames (andante/allegro/presto,
 * see migration 0005) — meaningless to a non-technical clinic operator. Map
 * through here at EVERY render site so the raw id never reaches the UI. Falls
 * back to the id itself so an unknown tier degrades visibly instead of blanking.
 */
const TIER_LABELS: Record<string, string> = {
  andante: 'Standard',
  allegro: 'Rapid',
  presto: 'Foarte rapid',
};

export function tierLabel(tierId?: string | null): string {
  if (!tierId) return '—';
  return TIER_LABELS[tierId] ?? tierId;
}
